define( function() {
	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ../~/jquery/src/ajax/var/rquery.js
// module id = 150
// module chunks = 0